import { Grid, GridItem } from './Grid';

export const CenteredContent = ({ children, height = 'auto', width = 'auto' }) => {
    return (
        <Grid numberOfColumns={1} height={height} width={width}>
            <GridItem alignSelf="center" justifySelf="center">
                {children}
            </GridItem>
        </Grid>
    );
};
